import styled from "styled-components";

const StyledErrorContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const StyledErrorContent = styled.div`
    width: 40%;
    flex-direction: column;

    h1,
    h3,
    p {
        margin-bottom: 0.7em;
    }
`;

export { StyledErrorContainer, StyledErrorContent };
